module.exports = __webpack_public_path__ + "static/img/3Act.89700206.png";